export class APIError extends Error {
  private errorCode: string;
  private statusCode: number;

  constructor(message: string, errorCode: string, statusCode: number) {
    super(message);
    this.errorCode = errorCode;
    this.statusCode = statusCode;
  }

  public getErrorCode() {
    return this.errorCode;
  }

  public getStatusCode() {
    return this.statusCode;
  }
}
